import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "action-list" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = { class: "dialog-footer" }

import { getCurrentInstance, reactive, ref } from 'vue'
import { useStore } from '@/store/index'
import Pagination from '@/components/Pagination.vue'
import { getBirthdayActivityListApi, saveBirthdayShipInfoApi, getAddrLinkApi } from "@/apis/order";
import { getExpressInfoApi } from '@/apis/order'
import { downloadFile, copyText } from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'GiftList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()

const filters = reactive({
    receiver_name: '',
    receiver_phone: '',
    status: '', // 0-待领取，1-待发货，2-已发货
    start_date: '',
    end_date: '',
    page: 1, // 当前页码
    page_size: 10, // 每页显示条数
})

// 获取列表数据
const tableData = ref([])
const total = ref(0)
const statusTypeMap = { 0: 'info', 1: 'warning', 2: 'success' }
const getList = async () => {
    const { start_date, end_date } = filters
    if (start_date && end_date && start_date > end_date) {
        return proxy.$message({ type: 'error', message: '开始时间不能大于结束时间' })
    }

    const { code, data, msg } = await getBirthdayActivityListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    tableData.value = data.data
    total.value = data.total
}
getList()

/****************************** 发货弹窗 -- begin *****************************/
const shipDialog = ref(false)
const shipForm = ref({
    id: '',
    express_no: '',
    express_company: '',
    remark: '',
})
// 打开发货弹窗
const openShipDialog = (row: any) => {
    const { id, express_company, express_no, remark } = row
    shipForm.value = {
        id,
        express_no,
        express_company,
        remark,
    }
    shipDialog.value = true
}
// 关闭发货弹窗
const closeShipDialog = () => {
    shipForm.value = {
        id: '',
        express_no: '',
        express_company: '',
        remark: '',
    }
    shipDialog.value = false
}
// 获取物流公司信息
const getExpressInfo = async () => {
    const { express_no } = shipForm.value
    if (!express_no) {
        return
    }
    const { code, data, msg } = await getExpressInfoApi(express_no) as any
    if (code != 200) {
        shipForm.value.express_company = ''
        return proxy.$message({ type: 'error', message: msg })
    }

    shipForm.value.express_company = data.current_express_no
}
// 保存发货信息
const onShipSave = async () => {
    const { id, express_no, express_company, remark } = shipForm.value
    if (!express_no || !express_company) {
        return proxy.$message({ type: 'error', message: '请填写完整发货信息' })
    }
    const { code, msg } = await saveBirthdayShipInfoApi({
        id,
        express_no,
        express_company,
        remark,
    }) as any
    if (code != 200) {
        return proxy.$message({ type: 'error', message: msg })
    }
    proxy.$message({ type: 'success', message: '保存成功' })
    shipDialog.value = false
    getList()
}
/****************************** 发货弹窗 -- end *****************************/


/****************************** 批量发货弹窗 -- begin *****************************/
const batchShipDialog = ref(false)
const fileList = ref([])
const batchShipUrl = `/api/cake_api/merch_gift_batch_express?user_id=${store.state.user.userInfo.id}&user_name=${encodeURIComponent(store.state.user.userInfo.username || '')}`
const openBatchShipDialog = () => {
    batchShipDialog.value = true
}
const closeBatchShipDialog = () => {
    proxy.$refs.batchShipForm.clearFiles()
    batchShipDialog.value = false
}
const onBatchShipUpload = () => {
    if (fileList.value.length === 0) {
        return proxy.$message({ type: 'warning', message: '请选择文件' })
    }
    proxy.$refs.batchShipForm.submit()
}
const onUploadSuccess = (res) => {
    const { code, msg } = res
    if (code != 200) {
        proxy.$message({ type: 'error', message: msg })
        proxy.$refs.batchShipForm.clearFiles()
        return
    }
    
    proxy.$message({ type: 'success', message: '发货成功' })
    proxy.$refs.batchShipForm.clearFiles()
    batchShipDialog.value = false
    setTimeout(() => {
       getList()
    }, 2000)
}
const onUploadError = () => {
    proxy.$message({ type: 'error', message: '批量发货文件上传失败' })
}
const onExceed = () => {
    proxy.$message({ type: 'warning', message: '最多只能上传一个文件' })
}

const downloadBatchShipTemplate = () => {
    downloadFile('/cake_api/merch_gift_batch_template')
}
/****************************** 批量发货弹窗 -- end *****************************/


/****************************** 生成专属送礼链接弹框 -- begin *****************************/
const genLinkDialog = ref(false)
const genLinkForm = ref({
    phone: '',
    link: '',
})
// 打开发货弹窗
const openGenLinkDialog = () => {
    genLinkDialog.value = true
}
// 关闭发货弹窗
const closeGenLinkDialog = () => {
    genLinkForm.value = {
        phone: '',
        link: '',
    }
    genLinkDialog.value = false
}
// 生成链接
const onGenLink = async () => {
    const { phone } = genLinkForm.value
    if (!/^1[3-9]\d{9}$/.test(phone)) {
        return proxy.$message({ type: 'warning', message: '请输入正确的用户手机号' })
    }
    const { code, data, msg } = await getAddrLinkApi(phone) as any
    if (code != 200) {
        return proxy.$message({ type: 'error', message: msg })
    }

    genLinkForm.value.link = data.gift_url
    await getList()
}
// 复制链接
const onCopyLink = () => {
    const { link } = genLinkForm.value
    if (!link) {
        return proxy.$message({ type: 'warning', message: '请先生成链接' })
    }
    copyText(link)
    proxy.$message({ type: 'success', message: '复制成功' })
}
// 复制订单列表中的专属送礼链接
const onCopyGiftLink = (link: string) => {
    copyText(link)
    proxy.$message({ type: 'success', message: '复制成功' })
}
/****************************** 生成专属送礼链接弹框 -- end *****************************/

// 导出
const onExport = () => {
    downloadFile('/cake_api/merch_gift_export', filters)
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.receiver_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.receiver_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货人",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.receiver_phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.receiver_phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货手机号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.status) = $event)),
        placeholder: "状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待领取",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "待发货",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "已发货",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "提交开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "提交结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openBatchShipDialog
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode("批量发货")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openGenLinkDialog
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [
          _createTextVNode("生成专属送礼链接")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      class: "mt20",
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "礼物订单号",
          prop: "gift_no",
          "min-width": "170"
        }),
        _createVNode(_component_el_table_column, {
          label: "用户信息",
          "min-width": "160"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("p", null, "用户ID：" + _toDisplayString(row.user_id), 1),
            _createElementVNode("p", null, "用户：" + _toDisplayString(row.user_name || '-'), 1),
            _createElementVNode("p", null, "手机号：" + _toDisplayString(row.mobile), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "用户生日",
          prop: "birthday"
        }),
        _createVNode(_component_el_table_column, {
          label: "专属送礼链接",
          "min-width": "260"
        }, {
          default: _withCtx(({row}) => [
            (row.gift_url)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  class: "gift-link",
                  type: "primary",
                  title: row.gift_url,
                  onClick: ($event: any) => (onCopyGiftLink(row.gift_url))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.gift_url), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "onClick"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "--"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "收货人信息",
          "min-width": "200"
        }, {
          default: _withCtx(({row}) => [
            (row.receiver_name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", null, "姓名：" + _toDisplayString(row.receiver_name), 1),
                  _createElementVNode("p", null, "联系方式：" + _toDisplayString(row.receiver_phone), 1),
                  _createElementVNode("p", null, "收货地址：" + _toDisplayString(row.address_full), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "用户尚未领取"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "claimed_at",
          label: "提交时间"
        }),
        _createVNode(_component_el_table_column, { label: "物流信息" }, {
          default: _withCtx(({row}) => [
            (!row.express_no)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" -- ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", null, "物流公司：" + _toDisplayString(row.express_company), 1),
                  _createElementVNode("p", null, "物流单号：" + _toDisplayString(row.express_no), 1),
                  _createElementVNode("p", null, "上传时间：" + _toDisplayString(row.shipped_at), 1),
                  _createElementVNode("p", null, "上传人：" + _toDisplayString(row.shipped_by_name || '-'), 1)
                ], 64))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_tag, {
              type: statusTypeMap[row.status]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.status_name), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: row.status == 0,
                onClick: ($event: any) => (openShipDialog(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.status == 2 ? '修改物流' : '发货'), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "订单发货",
      modelValue: shipDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((shipDialog).value = $event)),
      onClose: closeShipDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, { onClick: closeShipDialog }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onShipSave
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: shipForm.value,
          "label-width": "170px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "物流单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  clearable: "",
                  placeholder: "请填写物流单号",
                  modelValue: shipForm.value.express_no,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((shipForm.value.express_no) = $event)),
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (shipForm.value.express_no = shipForm.value.express_no.replace(/[^a-zA-Z0-9\-\(\)]/g, ''))),
                  onBlur: getExpressInfo
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "物流公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: shipForm.value.express_company,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((shipForm.value.express_company) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: shipForm.value.remark,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((shipForm.value.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量订单发货",
      modelValue: batchShipDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((batchShipDialog).value = $event)),
      onClose: closeBatchShipDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, { onClick: closeBatchShipDialog }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: onBatchShipUpload
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form",
          "label-width": "170px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "批量发货：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  ref: "batchShipForm",
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[11] || (_cache[11] = ($event: any) => ((fileList).value = $event)),
                  action: batchShipUrl,
                  "show-file-list": true,
                  "on-success": onUploadSuccess,
                  "on-error": onUploadError,
                  "auto-upload": false,
                  limit: 1,
                  "on-exceed": onExceed,
                  accept: ".xls,.xlsx"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "el-icon-plus avatar-uploader-icon" }, "选取文件", -1)
                  ])),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: downloadBatchShipTemplate
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode(_toDisplayString(`下载批量发货模板`))
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "填写手机号生成专属送礼链接",
      modelValue: genLinkDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((genLinkDialog).value = $event)),
      onClose: closeGenLinkDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, { onClick: closeGenLinkDialog }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: closeGenLinkDialog
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form",
          "label-width": "170px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户手机号：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: genLinkForm.value.phone,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((genLinkForm.value.phone) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "11"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  class: "ml10",
                  onClick: onGenLink
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("生成")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "专属链接：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: genLinkForm.value.link,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((genLinkForm.value.link) = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  class: "ml10",
                  onClick: onCopyLink
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("复制")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})